// Consistency panel of the organisation (administrator): labels and links for the findings `GET /collaborators/consistency` returns.
export const SEVERITY_LABELS = { action: "À traiter", check: "À vérifier", info: "Information" };
export const SEVERITY_ORDER = ["action", "check", "info"];

// A finding points at a fiche, a service or an account: the page where the administrator can look at it (and fix it).
export function subjectLink(item) {
  if (item.subject_type === "collaborator") return { to: `/collaborateurs/${item.subject_id}` };
  if (item.subject_type === "service") return { to: "/collaborateurs/organisation/services" };
  if (item.subject_type === "account") return { to: "/users", state: { openUser: item.subject_id } };
  if (item.subject_type === "mandate_type") return { to: "/collaborateurs/organisation/types-de-mandat" };
  return null;
}

export function subjectName(item) {
  const label = item.subject?.label;
  if (label) return item.subject.archived ? `${label} (archivée)` : label;
  return { collaborator: "Fiche introuvable", service: "Service introuvable", account: "Compte introuvable", mandate_type: "Type de mandat introuvable" }[item.subject_type] || "—";
}

const plural = (n, one, many) => `${n} ${n > 1 ? many : one}`;

// The small counter a finding carries, in plain words (never an identifier).
export function describeExtra(item) {
  const extra = item.extra || {};
  if (extra.reports) return plural(extra.reports, "personne sous sa responsabilité", "personnes sous sa responsabilité");
  if (extra.people) return plural(extra.people, "personne dans son équipe", "personnes dans son équipe");
  if (extra.members) return plural(extra.members, "membre ouvert", "membres ouverts");
  if (extra.levels) return `${extra.levels} niveaux`;
  if (extra.size) return `${extra.size} fiches au même nom`;
  if (extra.declared) return plural(extra.declared, "mandat déclaré", "mandats déclarés");
  if (extra.holders && extra.limit) return `${plural(extra.holders, "titulaire", "titulaires")} pour une limite de ${extra.limit}`;
  if (extra.verification) return { draft: "Brouillon, sans justificatif", to_verify: "Justificatifs joints, vérification non confirmée" }[extra.verification] || "";
  if (extra.role) return { head: "chef du service", deputy: "adjoint du service" }[extra.role] || extra.role;
  return "";
}

// « 500 sur 1 200 » once the page does not hold everything the filter selects.
export function pageSummary(shown, total) {
  return shown < total ? `${shown} sur ${total}` : plural(total, "constat", "constats");
}

export function totalFindings(counts) {
  return SEVERITY_ORDER.reduce((sum, severity) => sum + (counts?.per_severity?.[severity] || 0), 0);
}
